// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spreads {
  position: relative;
  display: inline-block;
  min-width: 69px;
  font-weight: 700 !important;
}

.team-lines {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--gap-xl);
  color: var(--color-deepskyblue);
}

.team-logo {
  height: 56px;
  width: 56px;
  position: relative;
  border-radius: 8px;
  object-fit: fill;
  min-height: 56px;
  padding: 4px;
}

.team-logo-pending {
  height: 56px;
  width: 56px;
  position: relative;
  border-radius: 8px;
  object-fit: fill;
  min-height: 56px;
  border: 2px solid #002129;
  padding: 4px;
}

.team-logo-win {
  height: 56px;
  width: 56px;
  position: relative;
  border-radius: 8px;
  object-fit: fill;
  min-height: 56px;
  background-color: rgba(0, 170, 114, 0.5019607843);
  border: 2px solid #00AA72;
  padding: 4px;
}

.team-logo-loss {
  height: 56px;
  width: 56px;
  position: relative;
  border-radius: 8px;
  object-fit: fill;
  min-height: 56px;
  background-color: rgba(204, 41, 60, 0.5019607843);
  border: 2px solid #CC293C;
  padding: 4px;
}

.team-logo-push {
  height: 56px;
  width: 56px;
  position: relative;
  border-radius: var(--br-9xs);
  object-fit: fill;
  min-height: 56px;
  background-color: rgba(90, 91, 92, 0.5019607843);
  border: 2px solid #5A5B5C;
}

.caption {
  margin: 0;
  height: 35px;
  position: relative;
  font-size: inherit;
  line-height: 38.5px;
  font-weight: 700 !important;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 25px;
}

.caption-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0px 0 0;
}

.image-1761-icon1 {
  height: 56px;
  width: 56px;
  position: relative;
  border-radius: var(--br-9xs);
  object-fit: cover;
  min-height: 56px;
}

.layout,
.visuals {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.visuals {
  flex: 1 1;
  justify-content: space-between;
  gap: var(--gap-xl);
}

.layout {
  align-self: stretch;
  justify-content: flex-start;
  padding: 0 6px;
  font-size: 32px;
}

.time {
  height: 12px;
  flex: 1 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 86px;
}

.teams-stat-bar-game-pending,
.time-display {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.time-display {
  align-self: stretch;
  flex-direction: row;
  padding: 0 78px 0 78.5px;
  font-size: 16px;
}

.teams-stat-bar-game-pending {
  width: 375px;
  background-color: #fff;
  flex-direction: column;
  padding: 16px 66px;
  box-sizing: border-box;
  gap: 6px;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  font-size: var(--font-size-xs);
  color: var(--color-black);
  font-family: var(--font-inter);
  margin: 0 auto;
}

.bottom-container {
  width: 100%;
  height: 100%;
  padding-left: 14px;
  padding-right: 14px;
  justify-content: space-between;
  align-items: center;
  display: inline-flex;
}

.score {
  width: 25px; /* Adjusted width for score */
  height: 12px;
  opacity: 0.98;
  text-align: center;
  color: black;
  font-size: 16px;
  font-family: Inter;
  font-weight: 700 !important;
  word-wrap: break-word;
}

.game-state {
  width: 97px;
  height: 12px;
  opacity: 0.98;
  text-align: center;
  color: black;
  font-size: 16px;
  font-family: Inter;
  font-weight: 700 !important;
}

.awaiting-pick {
  display: flex;
  width: 377px;
  height: 106px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0 auto;
}

.no-pick {
  display: flex;
  width: 377px;
  height: 106px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #CC293C;
  text-align: center;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0 auto;
}

.pick-button-text.other {
  width: 38px;
  color: #9D9D9D;
  text-align: center;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./src/components/SuperPickem/superPickemStyles/UserPick.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,2BAAA;AACJ;;AACE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,+BAAA;AAEJ;;AAAE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAGJ;;AADE;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAIN;;AAFI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iDAAA;EACA,yBAAA;EACA,YAAA;AAKN;;AAHI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iDAAA;EACA,yBAAA;EACA,YAAA;AAMN;;AAJI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gDAAA;EACA,yBAAA;AAOR;;AAJE;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAOJ;;AALE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,gBAAA;AAQJ;;AANE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;AASJ;;AAPE;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;AAUJ;;AARE;EACE,SAAA;EACA,8BAAA;EACA,kBAAA;AAWJ;;AATE;EACE,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;AAYJ;;AAVE;EACE,YAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAaJ;;AAXE;;EAEE,aAAA;EACA,uBAAA;EACA,2BAAA;AAcJ;;AAZE;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;AAeJ;;AAbE;EACE,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,yBAAA;EACA,8BAAA;EACA,cAAA;AAgBJ;;AAZE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;AAeJ;;AAZA;EACI,WAAA,EAAA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,qBAAA;AAeJ;;AAZA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;AAeJ;;AAXA;EACI,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAcJ;;AAXE;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAcJ;;AAZE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAeJ","sourcesContent":[".spreads {\n    position: relative;\n    display: inline-block;\n    min-width: 69px;\n    font-weight: 700 !important;\n  }\n  .team-lines {\n    align-self: stretch;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: var(--gap-xl);\n    color: var(--color-deepskyblue);\n  }\n  .team-logo {\n    height: 56px;\n    width: 56px;\n    position: relative;\n    border-radius: 8px;\n    object-fit: fill;\n    min-height: 56px;\n    padding: 4px;\n  }\n  .team-logo-pending {\n      height: 56px;\n      width: 56px;\n      position: relative;\n      border-radius: 8px;\n      object-fit: fill;\n      min-height: 56px;\n      border:  2px solid #002129;\n      padding: 4px;\n    }\n    .team-logo-win {\n      height: 56px;\n      width: 56px;\n      position: relative;\n      border-radius: 8px;\n      object-fit: fill;\n      min-height: 56px;\n      background-color: #00AA7280;\n      border:  2px solid #00AA72;\n      padding: 4px;\n    }\n    .team-logo-loss {\n      height: 56px;\n      width: 56px;\n      position: relative;\n      border-radius: 8px;\n      object-fit: fill;\n      min-height: 56px;\n      background-color: #CC293C80;\n      border:  2px solid #CC293C;\n      padding: 4px;\n    }\n    .team-logo-push {\n        height: 56px;\n        width: 56px;\n        position: relative;\n        border-radius: var(--br-9xs);\n        object-fit: fill;\n        min-height: 56px;\n        background-color: #5A5B5C80;\n        border:  2px solid #5A5B5C;\n      }\n\n  .caption {\n    margin: 0;\n    height: 35px;\n    position: relative;\n    font-size: inherit;\n    line-height: 38.5px;\n    font-weight: 700 !important;\n    font-family: inherit;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    min-width: 25px;\n  }\n  .caption-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    padding: 0px 0 0;\n  }\n  .image-1761-icon1 {\n    height: 56px;\n    width: 56px;\n    position: relative;\n    border-radius: var(--br-9xs);\n    object-fit: cover;\n    min-height: 56px;\n  }\n  .layout,\n  .visuals {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n  }\n  .visuals {\n    flex: 1;\n    justify-content: space-between;\n    gap: var(--gap-xl);\n  }\n  .layout {\n    align-self: stretch;\n    justify-content: flex-start;\n    padding: 0 6px;\n    font-size: 32px;\n  }\n  .time {\n    height: 12px;\n    flex: 1;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 86px;\n  }\n  .teams-stat-bar-game-pending,\n  .time-display {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n  .time-display {\n    align-self: stretch;\n    flex-direction: row;\n    padding: 0 78px 0 78.5px;\n    font-size: 16px;\n  }\n  .teams-stat-bar-game-pending {\n    width: 375px;\n    background-color: #fff;\n    flex-direction: column;\n    padding: 16px 66px;\n    box-sizing: border-box;\n    gap: 6px;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    font-size: var(--font-size-xs);\n    color: var(--color-black);\n    font-family: var(--font-inter);\n    margin:0 auto;\n  }\n\n\n  .bottom-container {\n    width: 100%;\n    height: 100%;\n    padding-left: 14px;\n    padding-right: 14px;\n    justify-content: space-between;\n    align-items: center;\n    display: inline-flex;\n}\n\n.score {\n    width: 25px; /* Adjusted width for score */\n    height: 12px;\n    opacity: 0.98;\n    text-align: center;\n    color: black;\n    font-size: 16px;\n    font-family: Inter;\n    font-weight: 700 !important;\n    word-wrap: break-word;\n}\n\n.game-state {\n    width: 97px;\n    height: 12px;\n    opacity: 0.98;\n    text-align: center;\n    color: black;\n    font-size: 16px;\n    font-family: Inter;\n    font-weight: 700 !important;\n}\n\n\n.awaiting-pick {\n    display: flex;\n    width: 377px;\n    height: 106px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #000;\n    text-align: center;\n    font-family: Inter;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin: 0 auto;\n  }\n\n  .no-pick {\n    display: flex;\n    width: 377px;\n    height: 106px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #CC293C;\n    text-align: center;\n    font-family: Inter;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin: 0 auto;\n  }\n  .pick-button-text.other {\n    width: 38px;\n    color: #9D9D9D;\n    text-align: center;\n    font-family: Inter;\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
